import React from "react";
import { Avatar } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";

import { Images } from "../../config";

import "./styles.css";

const ApplicationRow = ({ item = {}, ...props }) => {
  const appData = item;

  return (
    <div className="application-row" {...props}>
      <div className="flex gap-3 w-full">
        <div className="approw-image-container">
          <img
            src={appData?.universityProfilePic ?? Images.LogoIconOnly}
            className="approw-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = Images.LogoIconOnly;
            }}
          />
        </div>
        <div className="flex flex-col justify-center gap-2 w-[83%]">
          <div className="app-row-heading">{appData?.universityName}</div>
          <div className="app-row-subheading">
            {appData?.universityLocation}
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center gap-2 pl-4">
        <div className="app-row-heading">
          {appData?.universityDeadlines?.length > 0
            ? appData?.universityDeadlines[0].deadlineType
            : "NA"}
        </div>
        <div className="app-row-subheading">
          {appData?.universityDeadlines?.length > 0
            ? appData?.universityDeadlines[0].appDeadline
              ? moment(appData?.universityDeadlines[0].appDeadline).format(
                  "DD MMMM, YYYY"
                )
              : "NA"
            : "NA"}
        </div>
      </div>
      <div className="flex justify-between items-center gap-6">
        <div className="flex flex-col gap-2">
          <div className="flex gap-2 items-center">
            <div className="app-row-heading">
              {appData?.studentCount}{" "}
              {appData?.studentCount === 1 ? "Student" : "Students"}
            </div>
            <Avatar.Group>
              {appData?.studentProfiles?.map((item, index) => (
                <Avatar src={item} key={index} />
              ))}
            </Avatar.Group>
          </div>
          <div className="app-row-subheading">
            Applied in {appData?.universityName}
          </div>
        </div>
        <Link
          to={`/applications/${appData?.universityId}?university=${appData?.universityName}`}
        >
          <img
            src={Images.RightArrowCircled}
            // onClick={() => setApplicationModal(true)}
            className="cursor-pointer"
          />
        </Link>
      </div>
    </div>
  );
};

export default ApplicationRow;
